<template>
  <div class="new-page-main">
    <!--搜索查询栏-->
    <dt-search-bar style="padding: 20px 5px 5px">
      <template slot="filterSlot">
        <data-filter
          ref="dataFilterRef"
          :timeData="timeData"
          :schoolId="schoolId"
          :timesolt="1"
          :searchParams="searchParams"
          :contentObject="contentObject"
          :buttonColor="'#00CAAF'"
          @filter-data="filterData"
        ></data-filter>
      </template>
      <template slot="buttonSlot">
        <div style="display: flex; float: right">
          <!--搜索框-->
          <div class="big-data-search-input" v-if="activeType == 'teacher'">
            <input
              placeholder="支持教师姓名关键字搜索"
              class="big-data-input-cla"
              v-model="keyWord"
              v-on:keyup.enter="handleSearch"
            />
            <div class="big-data-search-btn" v-on:click="handleSearch">
              <div class="big-data-search-icon">
                <img
                  src="../../../../assets/images/databoard/detailPage/search.png"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </div>
          <!--导出按钮-->
          <div v-on:click="exportInfoToExcel" class="export-btn">列表导出</div>
        </div>
      </template>
    </dt-search-bar>
    <!--数据展示切换-->
    <div class="data-tab-area" ref="tabChangeRef">
      <Tabs type="card" @on-click="changeDataDetailsIndex" :value="tabsName">
        <TabPane label="课件详情" name="resTab"></TabPane>
        <TabPane label="微课详情" name="microTab"></TabPane>
        <TabPane label="作业详情" name="hwTab"></TabPane>
        <TabPane label="探究学习详情" name="studyTab"></TabPane>
        <TabPane label="互动答疑详情" name="interTab"></TabPane>
      </Tabs>
    </div>
    <div>
      <!--数据统计图-->
      <div class="data-statistics-img" ref="dataStatistics">
        <ul>
          <template v-for="(item, index) in dataSummaryMap">
            <data-statis-summary
              :num="item.value"
              :text="item.key"
              :remindText="item.remindText"
            ></data-statis-summary>
          </template>
        </ul>
      </div>
      <!--作业详情-->
      <school-homework-data-table
        v-if="tabsName == 'hwTab'"
        ref="hwTabRef"
        :activeType="activeType"
        :schoolId="schoolId"
        :schoolName="$route.query.schoolName"
        :keyWord="keyWord"
        :filters="filters"
        @info-table-client-height="infoTableHeight"
      ></school-homework-data-table>
      <!--微课详情-->
      <school-micro-data-table
        v-if="tabsName == 'microTab'"
        ref="microTabRef"
        :activeType="activeType"
        :schoolId="schoolId"
        :schoolName="$route.query.schoolName"
        :keyWord="keyWord"
        :filters="filters"
        @info-table-client-height="infoTableHeight"
      ></school-micro-data-table>
      <!--资源详情-->
      <school-resource-data-table
        v-if="tabsName == 'resTab'"
        ref="resTabRef"
        :activeType="activeType"
        :schoolId="schoolId"
        :schoolName="$route.query.schoolName"
        :keyWord="keyWord"
        :filters="filters"
        @info-table-client-height="infoTableHeight"
      ></school-resource-data-table>
      <!--探究学习详情-->
      <school-learning-data-table
        v-if="tabsName == 'studyTab'"
        ref="studyTabRef"
        :activeType="activeType"
        :schoolId="schoolId"
        :schoolName="$route.query.schoolName"
        :keyWord="keyWord"
        :filters="filters"
        @info-table-client-height="infoTableHeight"
      ></school-learning-data-table>
      <!--互动答疑详情-->
      <school-interact-data-table
        v-if="tabsName == 'interTab'"
        ref="interTabRef"
        :activeType="activeType"
        :schoolId="schoolId"
        :schoolName="$route.query.schoolName"
        :keyWord="keyWord"
        :filters="filters"
        @info-table-client-height="infoTableHeight"
      ></school-interact-data-table>
    </div>
  </div>
</template>

<script>
import {
  findHomeworkSummary,
  findHomeworkTeachersSummary,
  findMicroSummary,
  findMicroTeachersSummary,
  findResourceSummary,
  findResourceTeachersSummary,
  findLearningSummary,
  findLearningTeachersSummary,
  findInteractSummary,
  findInteractTeachersSummary
} from "../../../../service/bigDataApi.js";

const DtSearchBar = () => import("../../../../components/DtSearchBar");
const DataFilter = () => import("../../../../components/DataFilter");
const DataStatisSummary = () =>
  import("../../../../components/DataStatisSummary");
const SchoolHomeworkDataTable = () =>
  import("../../modules/SchoolHomeworkDataTable");
const SchoolMicroDataTable = () => import("../../modules/SchoolMicroDataTable");
const SchoolResourceDataTable = () =>
  import("../../modules/SchoolResourceDataTable");
const SchoolLearningDataTable = () =>
  import("../../modules/SchoolLearningDataTable");
const SchoolInteractDataTable = () =>
  import("../../modules/SchoolInteractDataTable");
export default {
  name: "act-statis-details",
  components: {
    DtSearchBar,
    DataFilter,
    DataStatisSummary,
    SchoolHomeworkDataTable,
    SchoolMicroDataTable,
    SchoolResourceDataTable,
    SchoolLearningDataTable,
    SchoolInteractDataTable,
  },
  watch: {
    keyWord: {
      handler(newValue, oldValue) {
        this.handleSearch();
      },
      deep: true,
    },
  },
  data() {
    return {
      //tab页标签
      tabsName: this.$route.query.tabCode,
      searchParams: {
        gradeId:
          this.$route.query.gradeid == undefined
            ? "0"
            : this.$route.query.gradeid,
        phase:
          this.$route.query.phase == undefined ? "0" : this.$route.query.phase,
      },
      //数据概览
      dataSummaryMap: [],
      //日期集合
      timeData: [
        {
          key: 1,
          value: "近一周",
        },
        {
          key: 2,
          value: "近一月",
        },
        {
          key: 3,
          value: "自定义",
        },
      ],
      schoolId: this.$route.query.schoolId,
      keyWord: "",
      filters: {},
      searchHeight: "", //搜索框高度
      //动态配置搜索框中的组件是否显示
      contentObject: {
        //是否显示时间切换按钮
        displayTimeFilter: true,
        //是否显示学段下拉框（仅多学段用户显示）
        displayPhaseFilter: true,
        //是否显示学科下拉框
        displaySubjectFilter: true,
        //是否显示年级下拉框
        displayGradeFilter: true,
        //是否显示班级下拉框
        displayClassFilter:
          this.$route.query.activeType == "class" ? true : false,
        //是否显示学年下拉框
        displayYearFilter:
          this.$route.query.activeType == "teacher" ? false : true,
      },
      //表格高度
      dataDetailStyle: {
        height: "883px",
      },
      //活跃场景类型：班级、教师、年级
      activeType: this.$route.query.activeType,
      //活跃场景名称
      activeTypeName: this.$route.query.activeTypeName,
    };
  },
  created() {
    this.setCurrentPath();
  },
  methods: {
    /**
     * 面包屑
     */
    setCurrentPath() {
      let currentPathArr;
      currentPathArr = [
        {
          title: "首页",
          path:
            this.$route.query.schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
              ? "cloudschooldataboard"
              : "schooldataboard",
          name:
            this.$route.query.schoolId == "75047a8a0990480f8abf3a39bc25f1ab"
              ? "cloudschooldataboard"
              : "schooldataboard",
          params: {
            schoolId: this.$route.query.schoolId,
          },
          query: {
            tokenId: this.$store.getters.token,
          },
        },
        {
          title: this.$route.query.schoolName,
          path: "",
          name: "schoolName",
        },
        {
          title: this.$route.query.activeTypeName,
          path: "",
          name: "homeworkList",
        },
      ];
      this.$store.commit("setCurrentPath", currentPathArr);
    },
    /**
     * 导出产品信息
     */
    exportInfoToExcel() {
      if (this.$refs[this.tabsName + "Ref"])
        this.$refs[this.tabsName + "Ref"].exportExcel();
    },
    /**
     * 点击切换详细数据
     */
    changeDataDetailsIndex(name) {
      this.tabsName = name;
      this.keyWord = "";
      this.queryDataListDetails(name);
      if (this.$route.query.activeType == "class") {
        if (this.tabsName != "microTab" && this.tabsName != "resTab") {
          this.contentObject.displaySubjectFilter = true;
          this.$refs.dataFilterRef.getSchoolSubject();
        } else {
          this.contentObject.displaySubjectFilter = false;
        }
      }
    },
    /**
     * 搜索
     */
    handleSearch() {
      this.queryDataListDetails(this.tabsName);
    },
    /**
     * 请求数据
     */
    queryDataListDetails(name) {
      let _this = this;
      if (name === "hwTab") {
        //请求作业数据概览
        _this.getHomeworkSummary();
      } else if (name === "microTab") {
        //请求微课数据概览
        _this.getMicroSummary();
      } else if (name === "resTab") {
        //请求资源数据概览
        _this.getResourceSummary();
      } else if (name === "studyTab") {
        //请求探究学习数据概览
        _this.getLearningSummary();
      } else if (name === "interTab") {
        //请求互动答疑数据概览
        _this.getInteractSummary();
      }
    },
    /**
     * 筛选数据
     */
    filterData(filters, searchHeight, type) {
      this.filters = filters;
      this.dataDetailStyle.height =
        this.searchHeight + searchHeight + 30 + "px";
      this.queryDataListDetails(this.tabsName);
    },
    /**
     * 获取表格的高度
     */
    infoTableHeight(tableHeight) {
      this.searchHeight =
        this.$refs.tabChangeRef.clientHeight +
        this.$refs.dataStatistics.clientHeight +
        tableHeight;
    },
    /**
     * 获取作业的数据概览
     */
    async getHomeworkSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        classyear: _this.filters.classyear,
        keyword: _this.keyWord,
        activetype: _this.activeType,
      };
      let functionName =
        _this.activeType == "teacher"
          ? findHomeworkTeachersSummary
          : findHomeworkSummary;
      let resultData = await functionName(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      if (resultData && Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "作业布置数",
            value:
              resultData.hw_total_num == null ? 0 : resultData.hw_total_num,
            remindText: "老师已发送的作业次数",
          },
          {
            key: "接收人数",
            value: resultData.stuNum == null ? 0 : resultData.stuNum,
            remindText: "每次作业接收人数的总和",
          },
          {
            key: "提交人数",
            value: resultData.hwSubmitNum == null ? 0 : resultData.hwSubmitNum,
            remindText: "每次作业提交人数的总和",
          },
          {
            key: "作业批改数",
            value:
              resultData.hwCorrectNum == null ? 0 : resultData.hwCorrectNum,
            remindText: "每次作业老师批改作业的总数",
          },
          {
            key: "作业提交率",
            value:
              resultData.hwSubmitRate == null
                ? 0 + "%"
                : _this.$utils
                    .toDecimal(resultData.hwSubmitRate * 100)
                    .toString() + "%",
            remindText: "提交人数/接收人数*100%",
          },
          {
            key: "作业批改率",
            value:
              resultData.hwCorrectRate == null
                ? 0 + "%"
                : _this.$utils
                    .toDecimal(resultData.hwCorrectRate * 100)
                    .toString() + "%",
            remindText: "批改作业数/提交人数*100%",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "作业布置数",
            value: 0,
            remindText: "老师已发送的作业次数",
          },
          {
            key: "接收人数",
            value: 0,
            remindText: "每次作业接收人数的总和",
          },
          {
            key: "提交人数",
            value: 0,
            remindText: "每次作业提交人数的总和",
          },
          {
            key: "作业批改数",
            value: 0,
            remindText: "每次作业老师批改作业的总数",
          },
          {
            key: "作业提交率",
            value: 0 + "%",
            remindText: "提交人数/接收人数*100%",
          },
          {
            key: "作业批改率",
            value: 0 + "%",
            remindText: "批改作业数/提交人数*100%",
          },
        ];
      }
    },
    /**
     * 获取微课的数据概览
     */
    async getMicroSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        keyword: _this.keyWord,
        classyear: _this.filters.classyear,
        activetype: _this.activeType,
      };
      let functionName =
        _this.activeType == "teacher"
          ? findMicroTeachersSummary
          : findMicroSummary;
      let resultData = await functionName(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      _this.dataSummaryMap = [
        {
          key: "微课分享数",
          value: 0,
          remindText: "老师分享微课的总次数",
        },
        {
          key: "微课接收数",
          value: 0,
          remindText: "教师分享微课接收人次的总和",
        },
        {
          key: "微课查看数",
          value: 0,
          remindText: "每份微课的看懂人数和未看懂人数的总和",
        },
        {
          key: "微课查看率",
          value: 0 + "%",
          remindText: "(看懂人数+未看懂人数)/接收到微课的人数*100%",
        },
        {
          key: "微课看懂率",
          value: 0 + "%",
          remindText: "看懂人数/已看人数*100%",
        },
      ];
      if (_this.activeType == "teacher") {
        _this.dataSummaryMap.unshift({
          key: "微课上传数",
          value: 0,
          remindText: "老师上传至网盘的微课总数",
        });
      }
      if (resultData && Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "微课分享数",
            value: resultData.share_num == null ? 0 : resultData.share_num,
            remindText: "老师分享微课的总次数",
          },
          {
            key: "微课接收数",
            value: resultData.stu_num == null ? 0 : resultData.stu_num,
            remindText: "教师分享微课接收人次的总和",
          },
          {
            key: "微课查看数",
            value: resultData.read_num == null ? 0 : resultData.read_num,
            remindText: "每份微课的看懂人数和未看懂人数的总和",
          },
          {
            key: "微课查看率",
            value:
              resultData.read_num == null || resultData.stu_num == null
                ? 0 + "%"
                : resultData.stu_num == 0
                ? 0 + "%"
                : _this.$utils
                    .toDecimal((resultData.read_num / resultData.stu_num) * 100)
                    .toString() + "%",
            remindText: "(看懂人数+未看懂人数)/接收到微课的人数*100%",
          },
          {
            key: "微课看懂率",
            value:
              resultData.understand_rate == null
                ? 0 + "%"
                : _this.$utils
                    .toDecimal(resultData.understand_rate * 100)
                    .toString() + "%",
            remindText: "看懂人数/已看人数*100%",
          },
        ];
        if (_this.activeType == "teacher") {
          _this.dataSummaryMap.unshift({
            key: "微课上传数",
            value: resultData.uploadCount == null ? 0 : resultData.uploadCount,
            remindText: "老师上传至网盘的微课总数",
          });
        }
      }
    },
    /**
     * 获取资源的数据概览
     */
    async getResourceSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        keyword: _this.keyWord,
        classyear: _this.filters.classyear,
        activetype: _this.activeType,
      };
      let functionName =
        _this.activeType == "teacher"
          ? findResourceTeachersSummary
          : findResourceSummary;
      let resultData = await functionName(params).catch(function (error) {
        _this.$Message.error(error.message);
      });
      if (resultData && Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "课件分享数",
            value: resultData.share_num == null ? 0 : resultData.share_num,
            remindText: "教师分享课件的总次数",
          },
          {
            key: "课件接收数",
            value: resultData.stu_num == null ? 0 : resultData.stu_num,
            remindText: "教师分享课件接收人次的总和",
          },
          {
            key: "课件查看数",
            value: resultData.read_num == null ? 0 : resultData.read_num,
            remindText: "接收课件人次中查看人次的总和",
          },
          {
            key: "课件查看率",
            value:
              resultData.read_rate == null
                ? 0 + "%"
                : _this.$utils
                    .toDecimal(resultData.read_rate * 100)
                    .toString() + "%",
            remindText: "（“课件查看数”/“课件接收数”）*100%",
          },
          {
            key: "课件看懂率",
            value:
              resultData.understand_rate == null
                ? 0 + "%"
                : _this.$utils
                    .toDecimal(resultData.understand_rate * 100)
                    .toString() + "%",
            remindText: "（“看懂课件数”/“课件查看数”）*100%",
          },
        ];
        if (_this.activeType == "teacher") {
          _this.dataSummaryMap.unshift({
            key: "课件上传数",
            value: resultData.uploadCount == null ? 0 : resultData.uploadCount,
            remindText: "教师上传至网盘的课件总数",
          });
        }
      } else {
        _this.dataSummaryMap = [
          {
            key: "课件上传数",
            value: 0,
            remindText: "教师上传至网盘的课件总数",
          },
          {
            key: "课件分享数",
            value: 0,
            remindText: "教师分享课件的总次数",
          },
          {
            key: "课件接收数",
            value: 0,
            remindText: "教师分享课件接收人次的总和",
          },
          {
            key: "课件查看数",
            value: 0,
            remindText: "接收课件人次中查看人次的总和",
          },
          {
            key: "课件查看率",
            value: 0 + "%",
            remindText: "（“课件查看数”/“课件接收数”）*100%",
          },
          {
            key: "课件看懂率",
            value: 0 + "%",
            remindText: "（“看懂课件数”/“课件查看数”）*100%",
          },
        ];
        if (_this.activeType == "teacher") {
          _this.dataSummaryMap.unshift({
            key: "课件上传数",
            value: 0,
            remindText: "教师上传至网盘的课件总数",
          });
        }
      }
    },
    /**
     * 获取探究学习的数据概览
     */
    async getLearningSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        keyword: _this.keyWord,
        classyear: _this.filters.classyear,
        activetype: _this.activeType,
      };
       let functionName =
        _this.activeType == "teacher"
          ? findLearningTeachersSummary
          : findLearningSummary;
      let resultData = await functionName(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      if (resultData && Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "发送次数",
            value: resultData.send_num == null ? 0 : resultData.send_num,
            remindText: "老师发送探究学习的总次数",
          },
          {
            key: "动态数量",
            value: resultData.dynamic_num == null ? 0 : resultData.dynamic_num,
            remindText: "每一个探究学习动态数量的总和",
          },
          {
            key: "接收人数",
            value:
              resultData.receive_stu_num == null
                ? 0
                : resultData.receive_stu_num,
            remindText: "每一个探究学习接收人数的总和",
          },
          {
            key: "参与人数",
            value: resultData.partake_num == null ? 0 : resultData.partake_num,
            remindText: "每一个探究学习参与人数的总和",
          },
          {
            key: "参与率",
            value:
              resultData.partake_rate == null
                ? 0 + "%"
                : _this.$utils
                    .toDecimal(resultData.partake_rate * 100)
                    .toString() + "%",
            remindText: "参与人数/接收人数*100%",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "发送次数",
            value: 0,
            remindText: "老师发送探究学习的总次数",
          },
          {
            key: "动态数量",
            value: 0,
            remindText: "每一个探究学习动态数量的总和",
          },
          {
            key: "接收人数",
            value: 0,
            remindText: "每一个探究学习接收人数的总和",
          },
          {
            key: "参与人数",
            value: 0,
            remindText: "每一个探究学习参与人数的总和",
          },
          {
            key: "参与率",
            value: 0 + "%",
            remindText: "参与人数/接收人数*100%",
          },
        ];
      }
    },
    /**
     * 获取互动答疑的数据概览
     */
    async getInteractSummary() {
      let _this = this;
      let params = {
        schoolid: _this.schoolId,
        startdate: _this.filters.startDate,
        enddate: _this.filters.endDate,
        subjectid: _this.filters.subjectId == 0 ? "" : _this.filters.subjectId,
        gradeid: _this.filters.gradeId == 0 ? (_this.filters.phaseGradeIds || "") : _this.filters.gradeId,
        classid: _this.filters.classId == 0 ? "" : _this.filters.classId,
        keyword: _this.keyWord,
        classyear: _this.filters.classyear,
        activetype: _this.activeType,
      };
       let functionName =
        _this.activeType == "teacher"
          ? findInteractTeachersSummary
          : findInteractSummary;
      let resultData = await functionName(params).catch(function (
        error
      ) {
        _this.$Message.error(error.message);
      });
      if (resultData && Object.keys(resultData).length > 0) {
        _this.dataSummaryMap = [
          {
            key: "消息总数",
            value:
              resultData.total_messages == null ? 0 : resultData.total_messages,
            remindText: "师生互动的消息总数",
          },
          {
            key: "学生消息数",
            value:
              resultData.stu_total_messages == null
                ? 0
                : resultData.stu_total_messages,
            remindText: "学生发出的消息总数",
          },
          {
            key: "教师消息数",
            value:
              resultData.tea_total_messages == null
                ? 0
                : resultData.tea_total_messages,
            remindText: "教师发出的消息总数",
          },
        ];
      } else {
        _this.dataSummaryMap = [
          {
            key: "消息总数",
            value: 0,
            remindText: "师生互动的消息总数",
          },
          {
            key: "学生消息数",
            value: 0,
            remindText: "学生发出的消息总数",
          },
          {
            key: "教师消息数",
            value: 0,
            remindText: "教师发出的消息总数",
          },
        ];
      }
    },
  },
  mounted() {
    if (
      this.$route.query.activeType == "grade" ||
      (this.$route.query.activeType == "class" && this.tabsName == "resTab")
    ) {
      this.contentObject.displaySubjectFilter = false;
    }

    if (this.$route.query.activeType == "teacher") {
      this.timeData.unshift({
        key: 0,
        value: "全部",
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../style/detailPage";

.panel-box {
  background-image: url("../../../../assets/images/databoard/modal-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.data-tab-area {
  padding-top: 0;
}

.big-data-search-btn {
  background: #00caaf !important;
  color: #fff;
  border-color: #00caaf !important;
}
</style>

<style lang="scss">
.data-tab-area {
  .ivu-tabs-bar {
    border-bottom: 0;
    background: #f2f5f3;
  }

  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-nav-container {
    height: 40px;
  }

  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    height: 40px;
    margin-right: 1px;
    padding: 9px 16px 4px;
  }

  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab-active {
    height: 40px;
    color: #00caaf;
  }

  .ivu-tabs-nav .ivu-tabs-tab:hover {
    color: #00caaf;
  }

  .ivu-tabs-nav-container:focus .ivu-tabs-tab-focused {
    border-color: #dcdee2 !important;
  }
}

.search-bar {
  .ivu-btn-primary {
    color: #fff;
    background-color: #00caaf;
    border-color: #00caaf;
  }
}
</style>
